// Minimal markdown → HTML for AI text output. Handles bold, bullets, paragraphs.
// Output is meant for `dangerouslySetInnerHTML`; input is escaped first.

const esc = (s) =>
  s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

export const renderMD = (text) => {
  if (!text) return "";
  let out = esc(text);
  out = out.replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>");
  // Collect contiguous "- " lines into a single <ul>.
  out = out.replace(/((?:^- .+(?:\n|$))+)/gm, (block) => {
    const items = block
      .trim()
      .split(/\n/)
      .map((l) => l.replace(/^- /, ""))
      .map((l) => `<li>${l}</li>`)
      .join("");
    return `<ul>${items}</ul>`;
  });
  // Paragraph wrap remaining double-newline blocks.
  out = out
    .split(/\n{2,}/)
    .map((block) =>
      block.startsWith("<ul>") || block.startsWith("<li>") ? block : `<p>${block.replace(/\n/g, "<br/>")}</p>`
    )
    .join("");
  return out;
};
